<template>
   <Form ref="form" :model="form" class="mt-20" @submit.native.prevent="()=>{}" :inline="inline" :rules="rules" :label-position="labelPosition" :label-width="labelWidth">
      <FormItem v-for="item in formItem" :prop="item.prop" :key="item.prop" :required="item.required" :label="item.label + ':'">
        <label slot="label" v-if="item.labelSlot">
          {{item.label}}：
          <BaseTooltip placement="top" :content="item.tip"></BaseTooltip>
        </label>
        <!-- select -->
        <template v-if="item.type==='select'">
          <Select v-model="form[item.prop]" class="form-item" @on-change="change($event, item.prop)" >
              <Option v-for="config in formExtraConfig[item.configKey]" :value="config.id" :key="config.id">{{ config.label }}</Option>
          </Select>
        </template>
        <!-- input -->
        <template v-else-if="item.type === 'input'">
          <Input :placeholder="item.placeholder" :icon="item.enterSearch ? 'ios-search' : ''" @on-click="inputEnterSearch(form[item.prop], item.prop, item.enterSearch)" @on-enter="inputEnterSearch(form[item.prop], item.prop, item.enterSearch)" :maxlength="item.maxLength" v-model="form[item.prop]" class="form-item" @on-blur="change($event, item.prop)"/>
          <span v-if="item.desc">{{item.desc}}</span>
        </template>
        <!-- textarea -->
        <template v-else-if="item.type === 'textarea'">
          <Input :placeholder="item.placeholder" type="textarea" :maxlength="item.maxLength" show-word-limit v-model="form[item.prop]" class="form-item" @on-blur="change($event, item.prop)"/>
          <span v-if="item.desc">{{item.desc}}</span>
        </template>
        <!-- radio -->
        <template v-else-if="item.type === 'radio'" class="form-item">
          <RadioGroup v-model="form[item.prop]" @on-change="change($event, item.prop)">
              <Radio :label="config.id" :disabled="config.disabled" v-for="config in formExtraConfig[item.configKey]" :key="config.id">
                {{config.label}}
              </Radio>
          </RadioGroup>
        </template>
        <!-- checkbox -->
        <template v-else-if="item.type === 'checkbox'" class="form-item">
          <CheckboxGroup v-model="form[item.prop]" @on-change="change($event, item.prop)">
            <Checkbox :disabled="config.disabled" v-for="config in formExtraConfig[item.configKey]" :key="config.id" :label="config.id">{{config.label}}</Checkbox>
          </CheckboxGroup>
        </template>
        <!-- upload -->
        <div v-else-if="item.type === 'upload'">
          <Upload 
            ref="upload"
            :max-size="item.uploadSize" 
            :format="['jpg','jpeg','png', 'bmp']" 
            :on-format-error="handleFormatError" 
            :data="uploadConfig" 
            :show-upload-list="false" 
            :on-success="uploadSuccess" 
            :on-exceeded-size="(v)=> {checkImageSize(v, item.uploadSize)}"
            :on-progress="imageProgress" 
            action="//upload.qiniup.com/"
          >
            <div @click="refreshUploadToken(item.prop)" v-if="!form[item.prop]" class="upload-wrap flex flex-center align-center cur-p">
              <Icon type="ios-add" size="24"/>
            </div>
            <img class="upload-wrap upload-img" v-else :src="form[item.prop]" @click="refreshUploadToken(item.prop)">
          </Upload>
          <div>{{item.desc}}</div>
          <div v-if="form[item.prop] && item.isDelete" style="cursor: pointer; color: #20bf64;" @click="deleteImage(item.prop)">删除图片</div>
        </div>
        <!-- switch -->
        <template v-else-if="item.type === 'switch'" class="form-item">
           <i-switch v-model="form[item.prop]" @on-change="change($event, item.prop)" />
        </template>
        <div v-else>{{form[item.prop]}}</div>
        <slot :name="item.prop"/>
      </FormItem>
      <div class="footer-spl" v-if="showButton"></div>
       <FormItem v-if="showButton" class="footer flex" :class="btnAlign === 'right' ? ' flex-end' : ''">
            <Button style="margin-left: 8px" @click="onCancel">{{cancelText}}</Button>
            <Button type="primary" @click="onSave">{{confirmText}}</Button>
        </FormItem>
    </Form>
</template>

<script>
import upload from '@/mixins/upload'
import { HOST } from '@/helpers/constants/common'

export default {
  mixins: [upload],
  props: {
    /**行内配置 */
    formItem: {
      type: Array,
      default: () => []
    },
    /**规则 */
    rules: {
      type: Object,
      default: () => {}
    },
    /**表单额外配置 */
    formExtraConfig: {
      type: Object,
      default: ()=> {}
    },
    /**form内容 */
    form: {
      type: Object,
      default: () => {}
    },
    /**label位置 */
    labelPosition: {
      type: String,
      default: 'right'
    },
    /**是否显示button */
    showButton: {
      type: Boolean,
      default: true
    },
    /** 确认按钮文字*/
    confirmText: {
      type: String,
      default: '保存'
    },
    /**取消按钮文字 */
    cancelText: {
      type: String,
      default: '取消'
    },
    /**按钮显示位置 */
    btnAlign: {
      type: String,
      default: 'left'
    },
    /**是否一行展示 */
    inline: {
      type: Boolean,
      default: false
    },
    /**label宽度 */
    labelWidth: {
      type: Number,
      default: 170
    }
  },
  methods: {
    /**表单内容切换 */
    change(v, key) {
      this.$emit('change', {form: this.form, key: key, value: v})
    },
    deleteImage(key) {
      this.form[key] = '';
      this.change('', key)
    },

    /**图片上传成功*/
    uploadSuccess(res) {
      let url = `${HOST.FILE_HOST}/${res.key}`
      this.form[this.uploadKey] = url
      this.change(url, this.uploadKey)
    },

    /**input-enter */
    inputEnterSearch(v, key, inputEnter) {
      if (inputEnter) {
        this.$emit('change', {form: this.form, key: key, value: v})
      }
    },

    /**保存 */
    onSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('save')
        } else {
          this.$Message.warning('请检查输入')
        }
      })
    },

    /**检查图片大小 */
    checkImageSize(file, maxSize) {
      this.$Message.error(`请上传大小为${maxSize/1024}M以内的图片`)
    },
    /**取消 */
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.form-item{
  max-width: 300px;
}
.upload-wrap{
  width: 200px;
  height: 200px;
  border: 1px dashed #e8e8e8;
}
.footer-spl{
  border-top: 1px solid #e8e8e8;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseForm/index.vue?4ab63bce